module.exports = __webpack_public_path__ + "static/media/icon_status.8d63eb9a.svg";